export var FilterType;
(function (FilterType) {
    FilterType["Regular"] = "regular";
    FilterType["Search"] = "search";
})(FilterType || (FilterType = {}));
